export default __webpack_public_path__ + "static-bigflip/media/online-umkm.0697e48b.webp";